import React from 'react';
import { FaUserAlt, FaPrescriptionBottleAlt, FaCalendarCheck } from 'react-icons/fa';
import { IoMdPaper } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

const NavigationButtons = () => {
  const navigate = useNavigate();

  const tabs = [
    { label: 'Add Appointment', icon: <FaCalendarCheck />, url: '/appointment' },
    { label: 'Prescription', icon: <IoMdPaper />, url: '/prescription' },
  ];

  return (
  <div className="flex flex-wrap gap-2">
  {tabs?.map((tab) => (
    <NavLink
      key={tab.label}
      to={tab.url}
      className={({ isActive }) => `
        flex items-center gap-2
        px-4 py-2 rounded-lg text-sm font-medium
        transition
        ${
          isActive
            ? "bg-blue-600 text-white"
            : "bg-white text-slate-700 hover:bg-slate-100"
        }
      `}
    >
      <span className="text-base">{tab.icon}</span>
      <span>
        {tab.label.charAt(0).toUpperCase() + tab.label.slice(1)}
      </span>
    </NavLink>
  ))}
</div>



  );
};

export default NavigationButtons;
